var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (categoryTitle) { 
__p+=' <h2 class="spaced-row"><a href="'+
((__t=( baseurl ))==null?'':__t)+
'/categories/'+
((__t=( categoryTitle.src ))==null?'':__t)+
'">'+
((__t=( categoryTitle.display ))==null?'':__t)+
'</a></h2> ';
 } 
__p+=' ';
 if (label.length) { 
__p+=' <label class="blocklabel">'+
((__t=( label ))==null?'':__t)+
'</label> ';
 } 
__p+=' <div class="score"> <h3 class="survey--item_title"><a href="'+
((__t=( baseurl ))==null?'':__t)+
'/'+
((__t=( dir ))==null?'':__t)+
'/'+
((__t=( href ))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</a></h3> <h4 class="score--tier score--tier_'+
((__t=( cat ))==null?'':__t)+
'">'+
((__t=( overall ))==null?'':__t)+
'</h4> </div> ';
 if (text) { 
__p+=' <p class="survey--question_text">'+
((__t=( text ))==null?'':__t)+
'</p> ';
 } 
__p+=' <div class="medium-up"> <p class="trigger js--table_trigger"> <a class="js--expand">Expand <span class="collecticon collecticon-sm-triangle-down"></span></a> <a class="js--collapse">Collapse <span class="collecticon collecticon-sm-triangle-up"></span></a> </p> <div class="collapse--target js--table_collapse"> <table class="spaced-row table table--scores table--span_'+
((__t=( length ))==null?'':__t)+
'"> ';
 if (isCommitment) { 
__p+=' <thead> <tr> <th></th> ';
 for (var i = 0, ii = services.length; i < ii; i += 2) { 
__p+=' <th colspan="2" class="col_';
 print(i / 2 % 2) 
__p+='"> <span class="table--service_label">'+
((__t=( services[i].type ))==null?'':__t)+
'</span> '+
((__t=( services[i].name ))==null?'':__t)+
' </th> ';
 } 
__p+=' </tr> <tr class="thead--end"> <th></th> ';
 for (var i = 0, ii = services.length; i < ii; ++i) { 
__p+=' ';
 if (i % 2) { 
__p+=' <th class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='">Privacy</th> ';
 } else { 
__p+=' <th class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='">Freedom of Expression</th> ';
 } 
__p+=' ';
 } 
__p+=' </tr> </thead> <tbody> ';
 levels.forEach(function (level, k) { 
__p+=' ';
 if (level.text !== 0) { 
__p+=' <tr> <td>'+
((__t=( level.text ))==null?'':__t)+
'</td> ';
 level.scores.forEach(function (score, i) { 
__p+=' <td class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='">'+
((__t=( score.score ))==null?'':__t)+
'</td> ';
 }); 
__p+=' </tr> ';
 } 
__p+=' ';
 if (follow && k === 0) { 
__p+=' </tbody></table> <p class="spaced-row label--insufficient">If no/insufficient evidence, then:</p> <table class="spaced-row table table--scores table--span_'+
((__t=( length ))==null?'':__t)+
'"> <thead> <tr> <th></th> ';
 for (var i = 0, ii = services.length; i < ii; i += 2) { 
__p+=' <th colspan="2" class="col_';
 print(i / 2 % 2) 
__p+='">'+
((__t=( services[i].name ))==null?'':__t)+
'</th> ';
 } 
__p+=' </tr> <tr class="thead--end"> <th></th> ';
 for (var i = 0, ii = services.length; i < ii; ++i) { 
__p+=' ';
 if (i % 2) { 
__p+=' <th class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='">Privacy</th> ';
 } else { 
__p+=' <th class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='">Freedom of Expression</th> ';
 } 
__p+=' ';
 } 
__p+=' </tr> </thead> <tbody> ';
  } 
__p+=' ';
 }); 
__p+=' <tr class="table--footer"> <td>Average Score</td> ';
 services.forEach(function (service, i) { 
__p+=' <td class="col_';
 print(Math.floor(i / 2 % 2)) 
__p+='"><span class="score--tier score--tier_'+
((__t=( cat ))==null?'':__t)+
'">'+
((__t=( service.displayScore ))==null?'':__t)+
'</span></td> ';
 }); 
__p+=' </tr> </tbody> ';
 } else { 
__p+=' <thead> <tr class="thead--end"> <th></th> ';
 services.forEach(function (service, i) { 
__p+=' <th class="col_';
 print (i % 2) 
__p+='"> <span class="table--service_label">'+
((__t=( service.type ))==null?'':__t)+
'</span> '+
((__t=( service.name ))==null?'':__t)+
' </th> ';
 }); 
__p+=' </tr> </thead> <tbody> ';
 levels.forEach(function (level, k) { 
__p+=' ';
 if (level.text !== 0) { 
__p+=' <tr> <td>'+
((__t=( level.text ))==null?'':__t)+
'</td> ';
 level.scores.forEach(function (score, i) { 
__p+=' <td class="col_';
 print(i % 2) 
__p+='">'+
((__t=( score.score ))==null?'':__t)+
'</td> ';
 }); 
__p+=' </tr> ';
 } 
__p+=' ';
 if (follow && k === 0) { 
__p+=' </tbody></table> <p class="spaced-row label--insufficient">If no/insufficient evidence, then:</p> <table class="spaced-row table table--scores table--span_'+
((__t=( length ))==null?'':__t)+
'"> <thead> <tr class="thead--end"> <th></th> ';
 services.forEach(function (service, i) { 
__p+=' <th class="col_';
 print (i % 2) 
__p+='">'+
((__t=( service.name ))==null?'':__t)+
'</th> ';
 }); 
__p+=' </tr> </thead> <tbody> ';
 } 
__p+=' ';
 }); 
__p+=' <tr class="table--footer"> <td>Average Score</td> ';
 services.forEach(function (service, i) { 
__p+=' <td class="col_';
 print(i % 2) 
__p+='"><span class="score--tier score--tier_'+
((__t=( cat ))==null?'':__t)+
'">'+
((__t=( service.displayScore ))==null?'':__t)+
'</span></td> ';
 }); 
__p+=' </tr> </tbody> ';
 } 
__p+=' </table> ';
 if (custom.length) { 
__p+=' <div class="spaced-row displaytext"> <h3>'+
((__t=( customId.toUpperCase() ))==null?'':__t)+
'&nbsp;Expanded Responses</h3> <ul> ';
 custom.forEach(function(item) { 
__p+=' <li>'+
((__t=( item.text ))==null?'':__t)+
'&nbsp;Possible score:&nbsp;'+
((__t=( item.score ))==null?'':__t)+
'</li> ';
 }); 
__p+=' </ul> </div> ';
 } 
__p+=' </div> </div> <div class="small-only"> <p class="trigger js--levels_trigger_small"> <a class="js--expand">Expand <span class="collecticon collecticon-sm-triangle-down"></span></a> <a class="js--collapse">Collapse <span class="collecticon collecticon-sm-triangle-up"></span></a> </p> <div class="collapse--target js--levels_collapse_small"> ';
 levels.forEach(function (level, k) { 
__p+=' <div class="spaced-row"> ';
 if (level.text) { 
__p+=' <p>'+
((__t=( level.text ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 level.scores.forEach(function (score, i) { 
__p+=' <p class="survey--inline"> <span class="score--tier score--tier_'+
((__t=( cat ))==null?'':__t)+
'">'+
((__t=( score.score ))==null?'':__t)+
'</span>&nbsp; <span class="survey--inline_name">'+
((__t=( services[i].name ))==null?'':__t)+
'&nbsp; ';
 if (isCommitment) { 
__p+=' ';
 if (i % 2) { 
__p+=' (Privacy) ';
 } else { 
__p+=' (Freedom of Expression) ';
 } 
__p+=' ';
 } 
__p+=' :&nbsp;</span>'+
((__t=( score.response ))==null?'':__t)+
'</p> ';
 }); 
__p+=' ';
 if (follow && k === 0) { 
__p+=' <p class="spaced-row label--insufficient">If no/insufficient evidence, then:</p> ';
 } 
__p+=' </div> ';
 }); 
__p+=' ';
 if (custom.length) { 
__p+=' <div class="spaced-row displaytext"> <h3>'+
((__t=( customId.toUpperCase() ))==null?'':__t)+
'&nbsp;Expanded Responses</h3> <ul> ';
 custom.forEach(function(item) { 
__p+=' <li>'+
((__t=( item.text ))==null?'':__t)+
'&nbsp;Possible score:&nbsp;'+
((__t=( item.score ))==null?'':__t)+
'</li> ';
 }); 
__p+=' </ul> </div> ';
 } 
__p+=' </div> </div>';
}
return __p;
};
